<!-- <div class="statbox" [style.border-color]="color"> -->

<div class="title text-truncate">{{ heading }}</div>

@if (statTemplate) {
    <div class="count">
        <ng-container [ngTemplateOutlet]="statTemplate" [ngTemplateOutletContext]="{ $implicit: count }">
        </ng-container>
    </div>
    <!-- <div class="count" [countUp]="count" [duration]="1500"></div> -->
} @else {
    <div class="count" [countUp]="count" [duration]="1500">{{ count }}</div>
}

<!-- </div> -->
